export const likeToDoData = {
  buttons: [
    {
      label: 'Replace car',
      id: 'replace',
    },
    {
      label: 'Repair car',
      id: 'repair',
    },
  ],
  title: 'What would you like to do?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/9da3525d35fc-tooliconpathways.jpg',
  },
  buttonsUnder30: [
    {
      label: 'Full refund',
      id: 'refund',
    },
    {
      label: 'Replace car',
      id: 'replace',
    },
    {
      label: 'Repair car',
      id: 'repair',
    },
  ],
}
